<template>
  <modal
      :width="398"
      height="auto"
      name="modal"
      :scrollable="true"
      classes="un-overflow"
      @closed="$emit('close')"
  >
    <div class="modal-content">
      <button type="button" class="close" @click="closeModal">
        <span aria-hidden="true">×</span>
      </button>
      <div class="modal-body">
        <h3 class="title-has-icon"><span class="icon-lines">|||</span> Выбор</h3>
        <div class="sep _h10"></div>
        <div class="row  color-green" id="col-toggle">
          <div class="col-6 form-item__field " v-for="(item, i) in columns" :key="i">

            <label class="check-label" :disabled="item.disabled">
              <div class="check-box-block">
                <input :disabled="item.disabled" v-model="item.checked" type="checkbox" class="debugCB"
                       @change="toggleSelectOnce(item)">
                <span class="label-inside">
                  {{ item.label }}
                </span>
              </div>
            </label>
          </div>
        </div>
        <button class="link" @click="toggleActive"><strong>{{ setAllTitle }}</strong></button>
        <div class="sep _h20"></div>
        <div class="row">
          <div class="col-6 col-md-auto">
            <button class="btn stat-filter--clear-btn" @click="closeModal">
              <span class="btn__text ml-1">Сохранить</span>
            </button>
          </div>
          <div class="col-6 col-md-auto">
            <button class="btn stat-filter--submit-btn" @click="removeAllChange">
              <span class="btn__text ml-1">Отменить</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>

export default {
  name: 'SourceColumnModal',
  props: {
    value: {},
    columns: {
      type: Array,
      default: () => []
    },
    toggleSelectOnce: {}
  },
  data() {
    return {
      allChecked: true
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.$modal.show(
            'modal'
        )
      }
    }
  },
  computed: {
    setAllTitle() {
      return this.allChecked ? 'Выключить все' : 'Включить все'
    }
  },
  methods: {
    closeModal(evt) {
      this.$modal.hide(
          'modal'
      )
      this.$emit('close', evt)
    },
    removeAllChange() {
      this.allChecked = true
      this.$emit('toggleAll', this.allChecked)
      this.closeModal()
    },
    toggleActive() {
      this.allChecked = !this.allChecked
      this.$emit('toggleAll', this.allChecked)
    }
  }
}
</script>
<style lang="scss" scoped>
.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: .5;
  background-color: transparent;
  border: 0;
}

.modal-content {
  position: relative;

  .close {
    position: absolute;
    right: 0;
    top: 0;
    padding: 15px;
    z-index: 1;
  }
.label-inside{
  overflow: hidden;
  display: inline-block;
  padding-left: 10px;
}
  .modal-body {
    text-align: left;
    padding: 27px;

    .title-has-icon {
      font-size: 22px !important;
      font-weight: 700;
      margin-bottom: 22px;
      line-height: 1 !important;
      padding-bottom: 0;
      padding-top: 0;
      text-transform: none;

      .icon-lines {
        font-size: 16px;
        margin-right: 5px;
      }
    }

    .form-item__field {
      position: relative;
      margin-bottom: 15px;
      padding-bottom: 8px;
    }

    .link {
      display: inline-block;
      margin-bottom: 20px;
      font-weight: 600;
      color: #141414;
      border: 0;
      border-bottom: 1px dashed #1414;
      padding: 0;
      outline: none;
      offset: none;
      background: none;

      &:hover {
        border-color: transparent;
      }
    }
  }

  .modal-footer {
    text-align: center;
    background: #F5F5F5;
    border: 0;
    border-radius: 0 0 20px 20px;
    padding: 20px;
  }
}

::v-deep {

}
.row {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}
.col-6 {
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}
.check-box-block{
  display: flex;
  align-items: flex-start;
  .debugCB{
    margin-top: 5px;
  }
}
</style>